import {take} from "rxjs/operators";
import {MonoTypeOperatorFunction} from "rxjs";

export function once<Type>(): MonoTypeOperatorFunction<Type> {
  return take(1);
}

